import {CalendarEventType} from '@/features/calendar/types/calendar-dto';

const getEventColor = (type: CalendarEventType) => {
    switch (type) {
        case CalendarEventType.Reservation:
            return {
                eventColor: 'bg-warning-1000',
            };
        case CalendarEventType.Accommodation:
            return {
                eventColor: 'bg-info-1000',
            };
        case CalendarEventType.HouseUse:
            return {
                eventColor: 'bg-success-1000',
            };
    }
};

const getEventNameKey = (type: CalendarEventType) => {
    switch (type) {
        case CalendarEventType.Reservation:
            return 'main.calendar.eventTypes.reservation';
        case CalendarEventType.Accommodation:
            return 'main.calendar.eventTypes.accommodation';
        case CalendarEventType.HouseUse:
            return 'main.calendar.eventTypes.houseUse';
        default:
            return 'main.calendar.eventTypes.unknown';
    }
}

export const CalendarConfig = {
    getEventColor,
    getEventNameKey
};